import * as React from 'react';
import Slider from 'react-slick';
import { Box, useMediaQuery, Typography } from '@mui/material';

import HydroQuebec_logo from '../images/HydroQuebec_logo.png';
import Desjardins_logo from '../images/Desjardins_logo.png';
import TroisRiviere_logo from '../images/TroisRiviere_logo.png';
import BRP_logo from '../images/BRP_logo.png';
import PMI_logo from '../images/PMI_logo.png';
import logo_Giro1 from '../images/logo_Giro1.png';
import agnico from '../images/agnico2.png';
import AIM_logo from '../images/AIM_logo.jpg';
import AIMQ_logo from '../images/AIMQ_logo.png';

const logos = [
  { img: HydroQuebec_logo, title: 'HydroQc' },
  { img: Desjardins_logo, title: 'Desjardin' },
  { img: TroisRiviere_logo, title: 'Trois-Riviere' },
  { img: BRP_logo, title: 'BRP' },
  { img: logo_Giro1, title: 'Giro' },
  { img: agnico, title: 'Agnico Eagle' },
  { img: 'https://www.jobillico.com/medias/logo-entreprise/0/0/exp_logo_2254_fr_2020_05_04_13_59_09.jpg', title: 'Sanimax' },
  { img: 'https://energir.com/files/energir_common/originals/PCGN_300x300.png', title: 'Energir' },
  { img: 'https://ccimoulins.com/logos/raymond-chabot-grant-thornton-1099.jpg', title: 'Raymond Chabot' },
  { img: AIM_logo, title: 'AIM' },
  { img: PMI_logo, title: 'PMI' },
  { img: AIMQ_logo, title: 'AIMQ' },
];

export default function NosClients() {
  const isMobile = useMediaQuery('(max-width:900px)');

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: true,
  };

  return (
    <Box sx={{ maxWidth: isMobile ? 300 : 600, margin: '0 auto' }}>
      <Slider {...settings}>
        {logos.map((logo) => (
          <Box
            key={logo.title}
            sx={{
              position: 'relative',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: isMobile ? 120 : 180,
              padding: 2,
              cursor: 'pointer',
              '&:hover .overlay': {
                opacity: 1,
              },
            }}
          >
            <img
              src={logo.img}
              alt={logo.title}
              style={{
                maxHeight: '100%',
                maxWidth: '100%',
                objectFit: 'contain',
                margin: 'auto',
                display: 'block',
              }}
            />
          </Box>
        ))}
      </Slider>
    </Box>
  );
}
